import DashboardEditor from "../../features/plugins/dashboard/components/DashboardEditor/DashboardEditor";
import { PageTable, Header } from '/src/layouts/page';
import { useLocation } from 'react-router-dom';
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import dashboardService from "/src/features/plugins/dashboard/services/dashboardService";
import { useNavigate } from "react-router-dom";
import urlWithRoutingCompany from '/src/utils/urlWithRoutingCompany';
import { Access } from "/src/utils/access";
function DashboardEditorPage() {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const { getDashboardChannel } = dashboardService;
    const [data, setData] = useState(location.state?.data);
    const [access, setAccess] = useState(location.state?.access);
    const [currentDashboardPrinted, setCurrentDashboardPrinted] = useState(params.id)

    const setDataWithUrl = async () => {
        setData(null);
        const [response, errors] = await getDashboardChannel({ id: params.id })
        if (errors != null) {
            console.log(errors)
            return navigate(urlWithRoutingCompany('/dashboards/list'))
        }
        let acc = location.pathname.includes("/view/") ? Access.Client : Access.Administrator;
        setAccess(acc);
        if (response.origin == 0 && acc == Access.Administrator) {
            return navigate(urlWithRoutingCompany('/dashboards/list'))
        }
        setData(response);
    }
    if (currentDashboardPrinted != params.id){
        setCurrentDashboardPrinted(params.id)
        setDataWithUrl();
    }
    useEffect(() => {
        if (data == null) {
            setDataWithUrl()
        }
    }, [])


    return (
        <PageTable>
            {
                data != null && access != null && data.dashboard != null &&
                <>
                    <Header title={<span>{"Dashboard " + (access == Access.Administrator ? "editor" : "") + " - " + (data.name != null ? data.name : data.dashboard.name)} <br></br> <span style={{ fontSize: "x-large", fontStyle: "italic" }}>For the bot : {data.dashboard.bot.name}</span> </span>}></Header>
                    <DashboardEditor data={data} access={access} id={params.id} />
                </>
            }

        </PageTable>
    );
}

export default DashboardEditorPage;